<template>
   <!-- Email Duplicate Dialog -->
   <PrimeDialog header="Applications Closed" v-model:visible="showCohortClose" modal>
    <p>Application Period for Cohort One has ended.<br><br> Dates for Cohort Two will be announced shortly</p>
    <!-- <p>The email supplied has alread been used to fill an application</p> -->
    <template #footer>
      <PrimeButton label="OK" @click="showCohortClose = false" />
    </template>
  </PrimeDialog>

  <div class="welcome-container">
    <!-- Welcome Header -->
    <h1>Welcome to Nessa Kud Accountants</h1>
    <p class="description">
      We are excited to partner with you to make an impact.
    </p>

    <!-- GDPR Consent Modal -->
    <div v-if="showGDPRModal" class="modal-overlay">
      <div class="modal">
        <h2>GDPR Notice</h2>

        <!-- Scrollable Text Box for GDPR Notice -->
        <div class="scrollable-textbox">
          <p>We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect
            your personal information
            when you use our website and services.</p>

          <h4>Information We Collect:</h4>

          <p>We may collect the following personal information: </p>

          <p>Personal Information: Name, email address, phone number, and other contact information.</p>
          <p> Usage Data: Information about how you use our website, such as your IP address, browser type, and device
            information.</p>


          <h4>How We Use Your Information:</h4>

          <p>We use your personal information to: </p>

          <ul>
            <li>Process your appplication and inquiries.</li>
            <li>Provide and improve our services.</li>
            <li>Send you notifications concerning your application</li>
            <li>Comply with legal obligations.</li>
          </ul>

          <h4>Data Sharing and Transfer:</h4>

          <p>We may share your personal information with:</p>

          <ul>
            <li>Service providers: To help us deliver our services (e.g., email providers, hosting providers).</li>
            <li>Law enforcement: To comply with legal obligations or law enforcement requests.</li>
          </ul>


          <h4>Data Security:</h4>
          <p>We implement appropriate technical and organizational measures to protect your personal information from
            unauthorized access, use, disclosure, alteration, or destruction.</p>

          <h4>Your Rights:</h4>

          <p>You have the following rights under the GDPR:</p>
          <ul>
            <li>Right to access: You can request access to your personal information.</li>
            <li> Right to rectification: You can request correction of inaccurate or incomplete personal information.
            </li>
            <li> Right to erasure: You can request deletion of your personal information.</li>
            <li>Right to restriction of processing: You can request restriction of processing of your personal
              information.</li>
            <li> Right to data portability: You can request transfer of your personal information to another data
              controller.</li>
            <li> Right to object: You can object to processing of your personal information.</li>
          </ul>

          <h4>Contact Us:</h4>
          <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us
            at: info@nessakud.com</p>

        </div>

        <!-- GDPR Agreement Checkbox -->
        <div class="gdpr-section">
          <label>
            <input type="checkbox" v-model="agreeToGDPR" />
            I consent to the use of cookies and data tracking in accordance with GDPR.
          </label>
        </div>

        <!-- Close and Accept Buttons -->
        <button @click="closeConsentModal" class="modal-close-button">
          Close
        </button>
        <button @click="confirmGDPRConsent" :disabled="!agreeToGDPR" class="modal-confirm-button">
          Accept
        </button>
      </div>
    </div>

    <!-- Apply Button (Disabled until GDPR is accepted) -->
    <button :disabled="!gdprConsentGiven" @click="startApplication" class="apply-button mr-2 mb-4">
      Request for Quote
    </button>

    <button :disabled="!gdprConsentGiven" @click="resumeApplication" class="resume-button">
      Fill KYC Form
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agreeToGDPR: false,       // Tracks whether the user has agreed to GDPR notice
      gdprConsentGiven: false,  // Tracks if GDPR consent has been confirmed
      showGDPRModal: true,     // Controls the visibility of the GDPR modal
      showCohortClose: false
    };
  },
  mounted() {
    // Show the GDPR modal as soon as the component is mounted
    
    const consent = localStorage.getItem("gdprConsent");
    if (consent === "true") {
      this.gdprConsentGiven = true;
      this.showGDPRModal = false;
    }
  },
  methods: {
    startApplication() {
      // Start the application process (redirect to application form or initiate form steps)
     




      this.$router.push({ name: 'Apply', params: { params: 'start' } });


      // this.showCohortClose = true;

      



    },

    resumeApplication() {

      //this.showCohortClose = true;
      this.$router.push({ name: 'Apply', params: { params: 'resume' } });

    },

    confirmGDPRConsent() {
      this.gdprConsentGiven = true;
      this.showGDPRModal = false; // Close modal after consent is given
      localStorage.setItem("gdprConsent", "true");
    },
    closeConsentModal(){
      // this.showGDPRModal = false;
      window.location.replace('https://greenfinancefacilitator.com')
    }
  },
};
</script>

<style scoped>
/* Full-page background image with overlay */
/* body {
  background: url('../assets/bg.jpg') no-repeat center center fixed;
  background-size: cover;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
} */

body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  /* Dark overlay to improve readability */
  z-index: -1;
}

/* Centered container with shadow */
.welcome-container {
  max-width: 600px;
  margin: 5vh auto;
  padding: 3rem;
  text-align: center;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 1;

}

h1 {
  color: #007ad9;
  margin-bottom: 1rem;
}

.description {
  color: #555;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

/* Modal Style */
.modal {
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal h2 {
  margin-bottom: 1rem;
  color: #007ad9;
}

/* Scrollable Textbox Style */
.scrollable-textbox {
  height: 60vh;
  /* Fixed height for scrolling */
  overflow-y: auto;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  color: #333;
  background-color: #f9f9f9;
  text-align: left;
}

/* GDPR Section */
.gdpr-section {
  margin-bottom: 1.5rem;
}

.gdpr-section label {
  font-size: 1rem;
  color: #333;
}

/* Button Styles */
.modal-close-button,
.modal-confirm-button {
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 0.5rem;
}

.modal-close-button {
  background-color: #ccc;
  color: #333;
}

.modal-confirm-button {
  background-color: #007ad9;
  color: #fff;
  transition: background-color 0.3s ease;
}

.modal-confirm-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.modal-confirm-button:hover:enabled {
  background-color: #005fa3;
}

.apply-button {
  padding: 0.8rem 2rem;
  font-size: 1rem;
  color: #fff;
  background-color: #16c94c;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.apply-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

.apply-button:hover:enabled {

  background-color: #0f8f36;
}




.resume-button {
  padding: 0.8rem 2rem;
  font-size: 1rem;
  color: #fff;
  background-color: #007ad9;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.resume-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  box-shadow: none;
}

.resume-button:hover:enabled {
  background-color: #005fa3;
}


</style>
